/**
 * @file Resource key builder for upload session identity.
 */

/**
 * Builds a stable session/resource key from scope prefix and id.
 * @param scope - Feature scope prefix (e.g. `transition`, `property`).
 * @param id - Resource identifier within the scope.
 * @returns Key in `scope:id` format used as session `id` and `resourceKey`.
 * @example buildResourceKey('transition', 'abc-123') → `'transition:abc-123'`
 */
export const buildResourceKey = (scope: string, id: string) => `${scope}:${id}`;
